// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sp {
    display: flex;
    flex-direction: column;
    align-items: center;

    margin-top: 5vh;
    width: 70vw;
}

.sp-header {
    display: flex;
    justify-content: space-around;
    align-items: center;
    width: 100%;
    color:  white;
    background-color: #289cef;
    padding: .5em 1em;
    font-size: 1.5em;
    font-weight: bold;

    border-radius: 12px;
}

.sp-header p {
    font-size: 1.2em;
}

.sp-header a {
    text-decoration: none;
    color: white;
    cursor: pointer;
    padding: .5em 1em;
    border-radius: 12px;
}

.sp-header a:hover {
    background-color: #4E7B9B;
}

.sp-body {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    justify-content: center;
    margin-top: 2vh;
}

.sp-body-record {
    display: flex;
    padding: 2vh 2vw;
    margin: 1vh 1vw;
    background-color: #289cef;
    color: white;
    border-radius: 12px;
    cursor: pointer;
}
.sp-body-record input {
    background-color: #ef2828;
    color: white;
    border: none;
    border-radius: 12px;
    padding: .5vh .5vw;
    font-size: 1.05em;
    font-weight: bold;
    cursor: pointer;
    height: fit-content;
}

.sp-body-record-conten {
    display: flex;
    flex-direction: column;
    margin-right: 2vw;
    font-size: 1.3em;
}`, "",{"version":3,"sources":["webpack://./src/pages/management/Spreadsheet.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;;IAEnB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;;IAEjB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,eAAe;IACf,WAAW;IACX,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,YAAY;IACZ,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;AACpB","sourcesContent":[".sp {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n\n    margin-top: 5vh;\n    width: 70vw;\n}\n\n.sp-header {\n    display: flex;\n    justify-content: space-around;\n    align-items: center;\n    width: 100%;\n    color:  white;\n    background-color: #289cef;\n    padding: .5em 1em;\n    font-size: 1.5em;\n    font-weight: bold;\n\n    border-radius: 12px;\n}\n\n.sp-header p {\n    font-size: 1.2em;\n}\n\n.sp-header a {\n    text-decoration: none;\n    color: white;\n    cursor: pointer;\n    padding: .5em 1em;\n    border-radius: 12px;\n}\n\n.sp-header a:hover {\n    background-color: #4E7B9B;\n}\n\n.sp-body {\n    display: flex;\n    flex-wrap: wrap;\n    width: 100%;\n    justify-content: center;\n    margin-top: 2vh;\n}\n\n.sp-body-record {\n    display: flex;\n    padding: 2vh 2vw;\n    margin: 1vh 1vw;\n    background-color: #289cef;\n    color: white;\n    border-radius: 12px;\n    cursor: pointer;\n}\n.sp-body-record input {\n    background-color: #ef2828;\n    color: white;\n    border: none;\n    border-radius: 12px;\n    padding: .5vh .5vw;\n    font-size: 1.05em;\n    font-weight: bold;\n    cursor: pointer;\n    height: fit-content;\n}\n\n.sp-body-record-conten {\n    display: flex;\n    flex-direction: column;\n    margin-right: 2vw;\n    font-size: 1.3em;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
